const AppConfig = {
  orderFormPath: window.APP_CONFIG?.orderFormPath ?? '',
  environment: window.APP_CONFIG?.environment ?? ''
};

export default AppConfig;
